import { ContextProviderEvent } from '../controllers/context-provider.js';
import { ValueNotifier } from '../value-notifier.js';
class ContextProvider extends ValueNotifier {
    constructor(root, context, initialValue) {
        super(initialValue);
        this.root = root;
        this.context = context;
        this.onContextRequest = (ev) => {
            if (ev.context !== this.context) {
                return;
            }
            ev.stopPropagation();
            this.addCallback(ev.callback, ev.subscribe);
        };
        this.attachListeners();
        // emit an event to signal a provider is available for this context
        this.root.dispatchEvent(new ContextProviderEvent(context));
    }
    attachListeners() {
        // @ts-ignore not wrong
        this.root.addEventListener('context-request', this.onContextRequest);
    }
    removeListeners() {
        // @ts-ignore not wrong
        this.root.removeEventListener('context-request', this.onContextRequest);
    }
}
export class GenericContextProvider {
    constructor(root = document) {
        this.root = root;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.provided = [];
    }
    provide(context, initialValue) {
        this.provided.push(new ContextProvider(this.root, context, initialValue));
    }
    destroy() {
        this.provided.forEach((provided) => {
            provided.removeListeners();
        });
    }
}
//# sourceMappingURL=generic-provider.js.map